import React from 'react';
import '../../styles/corpoClinico.css';
import PsicoGilca from '../../img/corpoClinico/PsicoSistemicaGilca.jpg';
import SemFoto from '../../img/corpoClinico/sem_foto.jpg';

const CorpoClinico: React.FC = () => {
  return (
    <>
      <div className='title_clinic'>
        <h2 className="titulo" id="Corpo_Clinico">Corpo Clínico</h2>
      </div>
      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={PsicoGilca} alt="Gilca" />
            </div>
            <div className="info-container">
              <h3 className="nome">Gilca Lucena Kortman</h3>
              <a href="https://lattes.cnpq.br/9350331289823529"
                target="_blank"
                rel="noopener noreferrer" className="btn-saber-mais">Saiba mais</a>
              <p className="descricao">
                "Dra. Gilca M. Lucena Kortman - Psicóloga CRP 07/38742 e psicopedagoga clínica e institucional, com Doutorado e Mestrado em Educação pela Unisinos. 
                É especialista em Neuropsicologia pela UFRGS, com atualizações permanentes pelo CBI of Miami e Incantato Neuropsicologia. 
                Possui formações em Terapia de Casal e Família pelo CEFI/RS, em Terapia Cognitivo-Comportamental para infância e adolescência pela Vila Elo Psicologia, 
                e em Análise do Comportamento e TCC Avançada para adultos pela Inteligência Psicológica de São Paulo.
                Também é especializada em Intervenção ABA aplicada ao autismo e outros transtornos do desenvolvimento pela PUC/PR. 
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="botao-container">
        <br></br>
      </div>
    </>
  );
};

export default CorpoClinico;